var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronRight = function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.529 2.862c.26-.26.682-.26.943 0l4.666 4.667c.26.26.26.682 0 .942l-4.666 4.667a.667.667 0 0 1-.943-.943L9.724 8 5.529 3.805a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  })));
};
export default SvgIconChevronRight;